import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import ShareOnSocialMedia from '../components/ShareOnSocialMedia';
import Date from '../components/Date';
import { Link } from 'gatsby';
import newsroomSplash from '../images/news/newspaper.jpg';
import mkBizRewardsCard from '../images/news/mk-business-rewards-card.png';
import AuthorJames from '../components/AuthorJames';
import DateAuthorSocial from '../components/DateAuthorSocial';
import ArticleTextOnly from '../components/ArticleTextOnly';
import NewsStoryHeader from '../components/NewsStoryHeader';

const Section = styled.section`
	color: black;
	display: flex;
	padding: 3em ${(props) => props.theme.paddingMobile};
	position: relative;
	z-index: 1;

	@media(${(props) => props.theme.mediumUp}) {
		padding: 3em ${(props) => props.theme.paddingMediumUp};
	}

	&.story {
		margin-top: -200px;
	}

	& article {
		padding-left: 0;
		padding-right: 0;
	}

	& figure {
		padding-left: 0;
		padding-right: 0;
	}

	& p {
		line-height: 1.6;
	}

	& .quote-author {
		font-style: italic;
		margin-top: 0;
		padding-top: 0;
	}

`; // Section

const DateAuthor = styled.div`
	position: static;
`;

const MKintroducesSmallBizCCOS = (props: any) => {
	const {
		data: {
			site: {
				siteMetadata: { endpoint },
			},
		},
	} = props;

	const icbaHeaderContent = <article style={{marginTop: `22px`}}>
		<h1><Link to='/newsroom'>News</Link></h1>
	</article>;

	const ccosSmallBusinessURL = 'https://mkdecision.com/MK-Introduces-CCOS-Small-Business';
	const pageTitleBeginning = 'MK Introduces Small Business CCOS';

	return <Layout
		pageTitle={pageTitleBeginning}
		// headerSplashBg={newsroomSplash}
		headerContent={icbaHeaderContent}
		metaDescription={'MK launches Small Business Credit Card Origination System (CCOS)'}
		headerSplashBgAverageColor={'#34414c'}
		CenteredSplashWrapperClass='newspaper'
		splashHeaderMinHeight={'320px'}
	>
		<div className='centeredWrapper'>
			<Section className='story row row-flush'>
				<NewsStoryHeader>
					<h2>MK launches Small Business Credit Card Origination System (CCOS)</h2>
					<img src={mkBizRewardsCard} alt='MK Small Business Credit Card' />
				</NewsStoryHeader>
				<div className='date-social-text row row-flush'>
					<DateAuthorSocial>
						<DateAuthor>
							<Date>Feb 12, 2019</Date>
							<AuthorJames />
						</DateAuthor>
						<ShareOnSocialMedia
							mkNewsStoryURL={ccosSmallBusinessURL}
							title={pageTitleBeginning}
						/>
					</DateAuthorSocial>
					<ArticleTextOnly>
						<p>San Diego, CA - MK today added small business card applications as a component of their Credit Card Origination System (CCOS). The platform expansion provides community banks, credit unions and other financial institutions with the technology needed to offer small business credit cards to small to medium sized enterprises.</p>

						<p>Community banks and credit unions share a common thread with small businesses: their connection to and reliance on their local communities. Small businesses often keep their money in local banks and credit unions, yet many of these institutions aren't offering small business credit cards, missing out on a substantial opportunity for growth.</p>

						<p>Numerous community banks are still underwriting manually, and have paper-intensive processes that are both time-consuming and prone to human error. Bigger banks are effectively marketing and delivering frictionless access to credit via automated decisioning.  In a world where over 60 percent of banking is done online, it is more likely that a contractor with an LLC or a freelancer would seek credit from institutions who utilize online, mobile responsive applications that they are accustomed to.</p>

						<p>Automated applications have improved customer experience, with frictional processes becoming a thing of the past.  Mobile responsive interfaces are becoming the new standard.  <cite>"As we have seen, many borrowers gravitate toward institutions with online applications."</cite> said Jeffrey Niesen, Senior Vice President at Bankers' Bank. <cite>"MK has been a great partner in developing a streamlined, mobile-first credit decisioning solution."</cite></p>

						<p>Small Business CCOS leverages MK's robust product suite to create an efficient credit card origination platform for community banks looking to enter the small business card market.  VP of Sales at MK Decision, Jon Benamoz said of the platform addition, <cite>"MK is bringing a tier-one FinTech solution to Community banks, credit unions, and other finance companies.  With the addition of our new business flow and CCOS products, local banks are engaging with businesses like never before. Our intuitive application workflow reduces inputs, and secure uploads make gathering documents simple."</cite></p>

						<p>MK's mission is to bring a modern, mobile-first, automated lending platform to local banks, credit unions, and small to mid-sized financial institutions alike, for better customer experiences and increased efficiency.</p>

						<p>Small Business CCOS is available to financial institutions today.<br /><Link to='/contact/'>Request a Demo</Link></p>
					</ArticleTextOnly>
				</div>
			</Section>
		</div>
	</Layout>;
};

export default MKintroducesSmallBizCCOS;

export const pageQuery = graphql`
	query {

		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;
